import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import "./ShopByCategory.css";

const TopDiscountedProducts = () => {
  const { addToWishlist, removeFromWishlist, wishlist } = useWishlist();
  const { addToCart } = useCart();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://madhusewingmachines.com/api/products");

        const filteredProducts = response.data.products.filter((product) => {
          const discountStr = product.discount?.toString().replace("%", "").trim();
          const discount = parseFloat(discountStr);
          return !isNaN(discount) && discount > 30;
        });

        setProducts(filteredProducts);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const handleWishlistToggle = (product) => {
    const isInWishlist = wishlist.some((item) => item._id === product._id);
    if (isInWishlist) {
      removeFromWishlist(product._id);
      toast.error("💔 Removed from Wishlist!", { position: "top-center", autoClose: 2000 });
    } else {
      addToWishlist(product);
      toast.success("❤️ Added to Wishlist!", { position: "top-center", autoClose: 2000 });
    }
  };

  const handleAddToCart = (product) => {
    addToCart(product);
    toast.success("🛒 Added to Cart!", { position: "top-center", autoClose: 2000 });
  };

  const handleImageClick = (id) => {
    navigate(`/product/${id}`);
  };

  return (
    <Container fluid className="py-5" style={{ backgroundColor: "#EFFBFF" }}>
      <h2 className="category-heading">✨ Top Discounted Products ✨</h2>

      <div className="product-scroll">
        {products.map((product) => {
          const isInWishlist = wishlist.some((item) => item._id === product._id);
          const mainImage = product.images?.length > 0 ? product.images[0]?.url : "";


          return (
            <div key={product._id} className="product-item">
              <Card className="border-0 shadow-sm p-3 bg-white text-center position-relative">

                {/* Discount Badge */}
                <span
                  className="position-absolute top-0 start-0 px-2 py-1 text-white"
                  style={{
                    backgroundColor: "red",
                    fontSize: "14px",
                    fontWeight: "bold",
                    borderRadius: "4px 0 4px 0",
                  }}
                >
                  {product.discount}
                </span>

                {/* Wishlist Heart Icon */}
                {isInWishlist ? (
                  <FaHeart
                    size={22}
                    className="position-absolute top-0 end-0 m-3"
                    style={{ cursor: "pointer", color: "red" }}
                    onClick={() => handleWishlistToggle(product)}
                  />
                ) : (
                  <FaRegHeart
                    size={22}
                    className="position-absolute top-0 end-0 m-3"
                    style={{ cursor: "pointer", color: "#ccc" }}
                    onClick={() => handleWishlistToggle(product)}
                  />
                )}

                {/* Product Image */}
                <Card.Img
                  variant="top"
                  src={mainImage ? `https://madhusewingmachines.com/uploads/${mainImage}` : "/placeholder.jpg"}
                  className="img-fluid"
                  style={{
                    height: "clamp(140px, 20vh, 170px)",
                    objectFit: "contain",
                    padding: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleImageClick(product._id)}
                />

                <Card.Body>
                  <Card.Title className="fw-bold" style={{ fontSize: "clamp(1rem, 2vw, 1.2rem)" }}>
                    {product.name}
                  </Card.Title>
                  <Card.Text className="text-muted">{product.type}</Card.Text>

                  <div className="d-flex justify-content-center align-items-center">
                    <span className="fw-bold fs-5">₹{product.price}</span>
                    <span className="text-muted mx-2" style={{ textDecoration: "line-through" }}>
                      ₹{product.originalPrice}
                    </span>
                   
                  </div>
                </Card.Body>

                <Button
                  className="w-100 fw-bold rounded-pill"
                  style={{ backgroundColor: "#64C3F9", border: "none", padding: "8px 0" }}
                  onClick={() => handleAddToCart(product)}
                >
                  Add to Cart
                </Button>
              </Card>
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default TopDiscountedProducts;
